import React from 'react';
import * as S from './NameChangeConfirmPop.styles';
import IconSelector from '@ibibo/icon-selector';

const NameChangeConfirmPop = ({confirmData, closeModal, confirmName}) => {

  console.log(confirmData);
    return(
      <S.CofirmPopOuterWrap>
        <S.ConfirmPopInnerWrap>
            <S.CofirmPopHeadText>Are you sure you want to proceed?</S.CofirmPopHeadText>
            <S.ConfirmInfoText>Please confirm name change request for your hotel booking</S.ConfirmInfoText>
        </S.ConfirmPopInnerWrap>
        <S.ConfirmPopInnerWrap>
          <S.UserOldNameText>Old Name: {confirmData.old_name}</S.UserOldNameText>
          <S.UserNameText>New Name: {confirmData.new_name}</S.UserNameText>
        </S.ConfirmPopInnerWrap>
        <S.ConfirmPopBtnWrap>
          <S.BackButtonWrap onClick={closeModal}>
            <S.BackButton>Cancel</S.BackButton>
          </S.BackButtonWrap>
          <S.ConfirmCancelBtn onClick={confirmName}>Confirm</S.ConfirmCancelBtn>
        </S.ConfirmPopBtnWrap>
    </S.CofirmPopOuterWrap>
    );
}

export default NameChangeConfirmPop;